import React, { useState } from "react"
import { Collapse } from "antd"

import "./styles.scss"

import Modal from "antd/lib/modal/Modal"
import { useAuth0 } from "@auth0/auth0-react"
import Button from "../../common/Button/Button"
import Header from "../../../assets/terms-and-conditions-header.png"
import UserAPI from "../../../api/User/UserAPI"
import AppStore from "../../../stores/App/AppStore"
import BrowserRouter, { BrowserRoutes } from "../../../stores/App/BrowserRouter"
import axios from "axios"
import CustomUserApi from "../../../api/CustomUser/CustomUserAPI"
const { Panel } = Collapse

interface Props {
  open?: boolean
}

export enum RiskFindingFormTypes {
  VendorValid = "vendor_valid",
}

// width of header picture
const WIDTH = 1443

const TERMS_AND_CONDITIONS_DOCUMENT_URL =
  process.env.PUBLIC_URL + "/CORL - Vendor Software Terms of Service.pdf"

function TermsAndConditionsModal({ open }: Props) {
  const [isOpen, setIsOpen] = useState(open)
  const [loading, setIsLoading] = useState(false)
  const { getAccessTokenSilently, user, logout } = useAuth0()

  async function userUpdated() {
    const authToken = await getAccessTokenSilently()

    const authenticatedUser = await CustomUserApi.Get(authToken)
    axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`
    AppStore.user = { ...authenticatedUser, picture: user?.picture }
  }

  async function onAccept() {
    setIsLoading(true)
    if (AppStore.user && AppStore.user.user_datum) {
      const response = await UserAPI.updateUserData(
        AppStore.user.user_datum.id,
        {
          accepted_terms_and_conditions: true,
        }
      )
      if (response.accepted_terms_and_conditions) {
        await userUpdated()
        BrowserRouter.push(BrowserRoutes.assessments)
        setIsOpen(false)
      } else {
        logout({ returnTo: window.location.origin })
      }
    }
    setIsLoading(false)
  }

  return (
    <Modal
      open={isOpen}
      title={
        <div
          style={{
            height: "20px",
          }}
        ></div>
      }
      width={WIDTH}
      footer={
        <div className="footer">
          <span>By continuing you accept the terms and conditions</span>
          <Button color="green" onClick={onAccept} loading={loading}>
            Continue
          </Button>
        </div>
      }
      onCancel={() => {
        logout({ returnTo: window.location.origin })
      }}
      destroyOnClose
      maskClosable={false}
      centered={true}
    >
      <Collapse>
        <Panel header="Terms and Conditions" key="1">
          <img
            alt="Logo"
            src={Header}
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              window.open(TERMS_AND_CONDITIONS_DOCUMENT_URL, "_blank")
            }}
          />
          <div className="terms-and-conditions-modal-content">
            <iframe
              width="100%"
              height="700px"
              src={TERMS_AND_CONDITIONS_DOCUMENT_URL}
              title="Terms and Conditions"
            />
          </div>
        </Panel>
      </Collapse>
    </Modal>
  )
}

export default TermsAndConditionsModal
